import React, { useEffect, useState, useContext, useRef } from "react";
import { Col, Row, Card, Form } from 'react-bootstrap';
import ReactToPrint from "react-to-print";
import { Button, ButtonGroup, Breadcrumb } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import Preloader from "../../components/Preloader/Preloader";
import { fetchAuthSession } from 'aws-amplify/auth';
import { phoneCode, journalCategory, journalsubCategory } from "../../ProData";
import axios from "axios";
import {Helmet} from 'react-helmet-async';
import { useSnackbar } from 'notistack';

const config = require('../../config.json');
const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// Custom CSS for animations and non-standard Bootstrap classes
const customStyles = `
  /* Animation for the email chip */
  .animate-scale-in {
    animation: scale-in 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  @keyframes scale-in {
    0% { transform: scale(0.5); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
  }

  /* Custom focus ring effect */
  .focus-within-ring:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(68, 76, 231, 0.25);
  }

  /* Modern inset shadow */
  .shadow-inset {
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.06);
  }

  /* Ensures the remove button is always visible */
  .remove-btn:hover {
    color: #000 !important;
  }
`;

// Main component for the email chip
const EmailChip = ({ email, onRemove, isPrimary, viewOnly }) => (
  // Chip container with conditional styling for the primary email
  <div
    className={`
      d-flex align-items-center gap-2 py-1 px-3 rounded-pill small fw-medium text-nowrap
      ${isPrimary ? 'bg-primary-subtle text-primary' : 'bg-secondary-subtle text-dark'}
      animate-scale-in
      overflow-hidden text-truncate shadow-sm
    `}
    title={email}
  >
    {isPrimary && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="flex-shrink-0 text-primary me-1"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    )}
    <span className="text-truncate">{email}</span>
    <button
      onClick={() => onRemove(email)}
      className="btn btn-sm p-0 border-0 text-dark remove-btn"
      aria-label={`Remove ${email}`}
      disabled={viewOnly} 
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  </div>
);

// Helper function to validate email format
const isValidEmail = (email) => {
  // Simple regex for email validation
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export  default function SubscriberForm(props) {
  const { handleSearch, toggle} = props;
  const { loggedUser, generateDate, validateLogin, subscriberFormType, setSubscriberFormType, subscriberDetails, setsubscriberDetails } = useContext(ProductContext);
  const { enqueueSnackbar } = useSnackbar();

  const [loaded, setLoaded] = useState(true);
  const [viewOnly, setViewOnly] = useState(true);
  const [subViewOnly, setSubViewOnly] = useState(true);
  const [inputValue, setInputValue] = useState('');
  const componentRef = React.useRef(null);
  const inputTitle = useRef(null);
  const inputAddressCity=useRef(null);
  const inputAddressPincode=useRef(null);
  const inputAddressState=useRef(null);
  const inputAreaCode=useRef(null);
  const inputCategoryID=useRef(null);
  const inputContactNo=useRef(null);
  const inputCopies=useRef(null);
  const inputCountry=useRef(null);
  const inputHouseName=useRef(null);
  const inputAddressStreet=useRef(null);
  const inputEmailID =useRef(null);
  const inputRegDate=useRef(null);
  const inputEndDate=useRef(null);
  const inputStartDate=useRef(null);
  const inputSubStatus=useRef(null);
  const inputSubscriberName=useRef(null);

  useEffect(()=>{
    //console.log("props.formType:", props.formType);
    //console.log("subscriberDetails:", subscriberDetails);
    if(loggedUser.isAuthenticated){
      if(props.formType){
      if(subscriberFormType==="New"||subscriberFormType==="Add"){
        setViewOnly(false);
        resetValues();
    }else if(subscriberFormType==="Edit"){
      setViewOnly(false);
    }else if(subscriberFormType==="View"){
      setViewOnly(true);
    }
  }else{
    setViewOnly(false);
    resetValues();
    setSubscriberFormType('New');
  }
  }else{
    resetValues();
    validateLogin();
  }
    return () => {
       // setSubscriberFormType("New");
       // resetValues();
      }
  },[]) 
  
  const handleEventKey=(event, item)=>{
    if(event.key === 'Enter'){
        if(item==="1"){
            inputSubscriberName.current.focus();
        }else if(item==="2"){
          inputRegDate.current.focus();
        }else if(item==="3"){
          inputSubStatus.current.focus();
        }else if(item==="4"){
          inputStartDate.current.focus();
        }else if(item==="5"){
          inputEndDate.current.focus();
        }else if(item==="6"){
          inputEmailID.current.focus();
        }else if(item==="7"){
          //console.log("event : ", event);
            inputAreaCode.current.focus();
        }else if(item==="8"){
          inputContactNo.current.focus();
        }else if(item==="9"){
          inputCategoryID.current.focus();
        }else if(item==="10"){
          inputCopies.current.focus();
        }else if(item==="11"){
          inputHouseName.current.focus();
        }else if(item==="12"){
          inputAddressStreet.current.focus();
        }else if(item==="13"){
          inputAddressCity.current.focus();
        }else if(item==="14"){
          inputAddressState.current.focus();
        }else if(item==="15"){
          inputAddressPincode.current.focus();
        }else if(item==="16"){
          inputCountry.current.focus();
        }
    }
}

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return <Button variant="outline-primary"  size="sm">Print</Button>;
  }, []);

  const handleSubcriberEdit=async(event)=>{
    event.preventDefault();
    try{
    const validationResult=validateFields();
   //const validationResult="passed";
    if(validationResult==="passed"){
     /* const {emailID}=subscriberDetails;
      const rawEmails = emailID
      .split(/[,\s]+/)                       // Split by comma or space
      .map(e => e.trim())                   // Trim each
      .filter(e => e.length > 0);  // Remove empty
      const validEmails = [];
      const invalidEmails = [];   

      rawEmails.forEach(email => {
      if (validEmailRegex.test(email)) {
        validEmails.push(email);
      } else {
        invalidEmails.push(email);
      }
    });*/
   // if(invalidEmails.length>0){
   //     enqueueSnackbar("Invalid Emails found",{variant : 'info'});
   // }else{
      setLoaded(false);
      const {title,subscriberName, subscriberID, areaCode,contactNo, emailID, emailList, houseName, addressStreet, addressCity, addressState,
      addressPincode, country, copies, categoryID,subStatus, regDate, startDate, endDate, subscriptionType, subGender, subCategory}=subscriberDetails;
      const tupdatedOn=await generateDate();
      var tsubscriptionType=subscriptionType;
      if(!subscriptionType){tsubscriptionType="NA"}
      var tsubGender=subGender;
      if(!subGender){tsubGender="NA"}
      var tsubCategory=subCategory;
      if(!subCategory){tsubCategory="NA"}
      const subscriberid=subscriberID;
      //const applicationStatus="Pending Approval";
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      //const tapplicantName=firstName+" "+middleName+ " "+lastName;
      
      const params={
        subscriberID: subscriberID, title:title,subscriberName:subscriberName, areaCode:areaCode, contactNo:contactNo, emailID:emailID, 
        emailList:emailList, houseName:houseName, addressStreet:addressStreet, addressCity:addressCity, addressState:addressState, 
        addressPincode:addressPincode, country:country, copies:copies, categoryID:categoryID, subStatus:subStatus, startDate:startDate, 
        endDate:endDate, updatedBy:loggedUser.name, updatedOn:tupdatedOn, regDate:regDate, subscriptionType:tsubscriptionType, 
        subGender:tsubGender, subCategory:tsubCategory};
      console.log("Params : ", params);
      await axios.patch(`${config.api.invokeUrl}/subscribers/${subscriberid}`, params,{
        headers: {
          Authorization: idToken,
          'x-api-key':config.api.key
        }})
        .then(async(response)=>{
          //console.log("response : ", response); 
       await handleSearch();
       enqueueSnackbar(subscriberID + " - Successfully Updated.",{variant : 'success'});
        window.scrollTo(0,0);
        toggle();
        setLoaded(true);
        }).catch((error)=>{
          enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
          window.scrollTo(0,0);
          setLoaded(true);
        })
    }
        setLoaded(true);
  //}
      setLoaded(true);

      }catch(error){
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
    window.scrollTo(0,0);
    setLoaded(true);
    }
  }

  const generateSubscriberID=()=>{
    const current_datetime = new Date();
    //const fName=profileDetails.firstName.trim().replace(/\s/g, "");
    //const tfName= fName.substring(0,2).toUpperCase();
    //const lName=profileDetails.lastName.trim().replace(/\s/g, "");
    //const tlName= lName.substring(0,2).toUpperCase();
    var tempUserId="";
    const date_year = (current_datetime.getFullYear()).toString().substring(2,4);
    var date_month = (current_datetime.getMonth() + 1).toString();
    var month_value="";
    date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
    var date_date = (current_datetime.getDate().toString());
    var date_value="";
    date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
    var date_hours = (current_datetime.getHours().toString());
    var hours_value="";
    date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
    var date_minutes = (current_datetime.getMinutes().toString());
    var minutes_value="";
    date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
    const accountNo = tempUserId.concat(date_year,month_value, date_value, hours_value, minutes_value);
    return accountNo;
}

  const handleSubcriberNew=async(event)=>{
    event.preventDefault();
    try{
    const validationResult=validateFields();
    if(validationResult==="passed"){
      setLoaded(false);
      const {subscriberID, title,subscriberName, areaCode,contactNo, emailID, emailList, houseName, addressStreet, addressCity, addressState,
        addressPincode, country, copies, categoryID, regDate, startDate, endDate, subStatus, subscriptionType, subGender, subCategory}=subscriberDetails;
      //const clientID = "VJDEPTH";
      const todayDate=await generateDate();
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      const subscriberid=subscriberID;
         /* const parsedEmails = emailID
      .split(/[,\s]+/)                       // Split by comma or space
      .map(e => e.trim())                   // Trim each
      .filter(e => e.length > 0);           // Remove empty
        */

      const params={
        subscriberID: subscriberid, title:title,subscriberName:subscriberName, areaCode:areaCode, contactNo:contactNo, emailID:emailID, emailList:emailList,   
        houseName:houseName, addressStreet:addressStreet, addressCity:addressCity, addressState:addressState, addressPincode:addressPincode, 
        country:country, copies:copies, categoryID:categoryID, subStatus:subStatus, updatedBy:loggedUser.username, updatedOn:todayDate,
        regDate:regDate, startDate:startDate, endDate:endDate, subscriptionType:subscriptionType, subGender:subGender, subCategory:subCategory};
      //console.log("Params : ", params);
      await axios.post(`${config.api.invokeUrl}/subscribers/${subscriberid}`, params,{
        headers: {
          Authorization: idToken,
          'x-api-key':config.api.key
        }})
        .then(async(response)=>{
          //console.log("response : ", response); 
          if(response.status===201){
            enqueueSnackbar("Subscriber ID - " + subscriberid + " - Successfully Registered.",{variant : 'success'});
        window.scrollTo(0,0);
        resetValues();
      }else if(response.status===251){
        enqueueSnackbar("Duplicate Subscriber ID - "+ subscriberid + " - Found. Correct or Refresh the Subscriber ID and Try Again.",{variant : 'success'});
      window.scrollTo(0,0);      
      }
        setLoaded(true);
        }).catch((error)=>{
          enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
          window.scrollTo(0,0);
          setLoaded(true);
        })
        setLoaded(true);
    }
      }catch(error){
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
    window.scrollTo(0,0);
    setLoaded(true);
    }
  }

  const resetValues=()=>{
    const todayDate= generateDate();
    const subscriberid= generateSubscriberID();
    setsubscriberDetails({...subscriberDetails,subscriberID:subscriberid, title:'Mr',subscriberName:'', areaCode:'+91',contactNo:'', emailID:'', houseName:'', addressStreet:'', addressCity:'', addressState:'',
    addressPincode:'', country:'', copies:'', categoryID:'A',subStatus:'Active', regDate:todayDate, startDate:todayDate, endDate:todayDate});
  }

  const isEmailValid = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};


  // Focus the input when the container is clicked
  /*const focusInput = () => {
    inputRef.current?.focus();
  };*/

  const validateFields=()=>{
    const {subscriberID, title,subscriberName, areaCode,contactNo, emailID, houseName, addressStreet, addressCity, addressState,
        addressPincode, country, copies, categoryID}=subscriberDetails;     
         var returnValue="passed";
        if(subscriberID===""){
          enqueueSnackbar("Subscriber ID cannot be empty!",{variant : 'info'});
        returnValue="failed";
        }/*else if(!emailID.match(validRegex)){
          enqueueSnackbar("Enter correct Email Address!",{variant : 'info'});
      returnValue="failed";
      }*/else if(title===""){
        enqueueSnackbar("Title cannot be Empty",{variant : 'info'});
      returnValue="failed";
    }else  if(subscriberName===""){
      enqueueSnackbar("Name cannot be Empty",{variant : 'info'});
    returnValue="failed";
  }else  if(copies===""){
    enqueueSnackbar("Copies cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(categoryID===""){
    enqueueSnackbar("Category cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(areaCode===""){
    enqueueSnackbar("Area Code cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(contactNo===""){
    enqueueSnackbar("Mobile Number cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(emailID===""){
    enqueueSnackbar("Email Address cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(addressCity===""){
    enqueueSnackbar("City cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(addressState===""){
    enqueueSnackbar("State cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(houseName===""||addressStreet===""){
    enqueueSnackbar("Address cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(addressPincode===""){
    enqueueSnackbar("Address Postal Code cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else  if(country===""){
    enqueueSnackbar("Country cannot be Empty",{variant : 'info'});
  returnValue="failed";
  }else {
    returnValue="passed";
  }
  window.scrollTo(0,0);
  return returnValue;
  }

  const handleSubscriberIDEdit=(e)=>{
    e.preventDefault();
    setSubViewOnly(false);
  }

  const handleSubscriberIDRefresh=(e)=>{
    e.preventDefault();
    const subscriberid= generateSubscriberID();
    setsubscriberDetails({...subscriberDetails,subscriberID:subscriberid});
  }

  const handleSubscriberIDClose=(e)=>{
    e.preventDefault();
    setSubViewOnly(true);
  }

   // Function to add a single email
  const addEmail = async(email) => {
    // Trim whitespace and validate email
    const trimmedEmail = email.trim();
    console.log("Adding email: ", trimmedEmail);
    console.log("Current Email List: ", subscriberDetails.emailList);
    
    if (isValidEmail(trimmedEmail) && !subscriberDetails.emailList.includes(trimmedEmail)) {
      if (subscriberDetails.emailList.length === 0) {
        await setsubscriberDetails({...subscriberDetails, emailID:trimmedEmail,
          emailList: [trimmedEmail]}); // Set the first email as primary contact
        console.log("First email added as primary contact: ", trimmedEmail);
      } else {
          await setsubscriberDetails({...subscriberDetails, emailList:[...subscriberDetails.emailList, trimmedEmail]});
          console.log("Email added to list: ", [...subscriberDetails.emailList, trimmedEmail]);
        };
          return true; // Return true if successful
      }
    return false; // Return false if validation fails
      // Add the new email to the list
      // If this is the first email, set it as the primary contact
    }


 // Handle adding an email when the 'Enter' key is pressed
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      e.preventDefault(); // Prevent form submission
      addEmail(inputValue);
     // console.log("Input Value: ", inputValue);
      setInputValue(''); // Clear the input field
    }
  };

  // Handle adding multiple emails from a paste event
  const handlePaste = (e) => {
    e.preventDefault(); // Prevent the default paste behavior
    const pastedText = e.clipboardData.getData('text');
    // Split pasted text by common delimiters like comma, space, or semicolon
    const emailsToAdd = pastedText.split(/[\s,;]+/).filter(Boolean); // Filter out empty strings
    
    // Iterate over the list of emails and add them one by one
    emailsToAdd.forEach(email => addEmail(email));
    setInputValue(''); // Clear the input field
  };

  // Handle removing an email from the list
  const handleRemoveEmail = async(emailToRemove) => {
    const newEmailList = subscriberDetails.emailList.filter(email => email !== emailToRemove);
    //console.log("New Email List: ", newEmailList);
    // If the removed email was the primary one, assign a new primary
    if (subscriberDetails.emailID === emailToRemove) {
      // The new primary is the first email in the updated list, or null if empty
      await setsubscriberDetails({...subscriberDetails, 
        emailID:newEmailList.length > 0 ? newEmailList[0] : null,
        emailList: newEmailList});
    }else {
      // Just update the email list without changing the primary contact
      await setsubscriberDetails({...subscriberDetails, emailList: newEmailList});
    } 
  };



  return (
    <div>
    <Helmet>
      <title>Registration - Admin Office - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION</title>
      <meta name="description" content="Registration - Admin Office - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION" />
      <meta name="keywords" content="Registration - Admin Office - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION" /> 
    </Helmet>

        <Preloader show={loaded ? false : true} />
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><i className="fa fa-home" aria-hidden="true"></i></Breadcrumb.Item>
            <Breadcrumb.Item>subscriber</Breadcrumb.Item>
            <Breadcrumb.Item active>Registration Form</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0"> 
          <ButtonGroup>
          <ReactToPrint
        content={reactToPrintContent}
        documentTitle="student"
        trigger={reactToPrintTrigger}
      />
          </ButtonGroup>
        </div>
        </div>
     
      <div ref={componentRef}>
      <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
      {/* <>
      <style>{customStyles}</style>
      <div className="d-flex flex-column min-vh-100 p-4 bg-light font-sans justify-content-center">
        <div className="container-sm bg-white rounded-4 shadow-lg border p-4">
          <h1 className="h2 fw-bolder text-center mb-2 text-dark">
            Contact Emails
          </h1>
          <p className="text-muted text-center mb-4">
            Add recipient emails below. The first email entered will be the primary contact.
          </p>
          
           Email input and chips container 
          <div
            className="
              bg-white border rounded-4 p-3 d-flex flex-wrap align-items-center
              g-2 shadow-sm focus-within-ring
            "
          >
            {subscriberDetails.emailList.map((email) => (
              <EmailChip
                key={email}
                email={email}
                onRemove={handleRemoveEmail}
                isPrimary={email === subscriberDetails.emailID}
              />
            ))}
            <input
              type="email"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              onPaste={handlePaste}
              placeholder={subscriberDetails.emailList.length === 0 ? "Add recipients..." : ""}
              className="
                flex-grow-1 bg-transparent border-0 p-1 text-dark
                min-w-[150px] placeholder-text-muted
              "
            />
          </div>
            Display of current recipients 
          <div className="mt-4 bg-light border rounded-3 p-4 shadow-inset">
            <h2 className="h5 fw-semibold text-dark mb-3">
              Current Recipients ({subscriberDetails.emailList.length}):
            </h2>
            {subscriberDetails.emailList.length > 0 ? (
              <ul className="list-unstyled text-dark ps-3">
                {subscriberDetails.emailList.map(email => (
                  <li key={email}>
                    {email}
                    {email === subscriberDetails.emailID && (
                      <span className="badge text-bg-primary rounded-pill ms-2">
                        Primary
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted fst-italic">No emails have been added yet.</p>
            )}
          </div>
          
        </div>
      </div>
    </>*/}
        <Row>
            <Col md={2} className="mb-3">
              <Form.Group id="title">
                <Form.Label className="name_user">Title</Form.Label>
                <Form.Select value={subscriberDetails.title} 
                disabled={viewOnly} ref={inputTitle} onKeyDown={event=>{handleEventKey(event,"1")}} 
                onChange={(event)=>{setsubscriberDetails({...subscriberDetails, title:event.target.value})}}
               >
                  <option value="Fr">Fr</option>
                  <option value="Fr">Dr</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Sr">Sr</option>
                  <option value="Br">Br</option>
                  <option value="Rev">Rev</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="firstName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control type="text"  autoFocus placeholder="Enter Full Name" value={subscriberDetails.subscriberName}
                  disabled={viewOnly} ref={inputSubscriberName} onKeyDown={event=>{handleEventKey(event,"2")}} 
                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, subscriberName:(event.target.value).toUpperCase()})}}  
               />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group id="subscriberid">
                <Form.Label>Subscriber ID</Form.Label>
                <Form.Control required type="text" placeholder="Subscriber ID" value={subscriberDetails.subscriberID}
                  disabled={subViewOnly}
                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, subscriberID:(event.target.value).toUpperCase()})}}  
               />
              </Form.Group>
            </Col>
            <Col md={1} className="mb-3">
            <Form.Group id="subsid">
                <Form.Label> </Form.Label>
            {!viewOnly && <>{subViewOnly ? <><div><i className="fa fa-pencil" aria-hidden="true" onClick={event=>{handleSubscriberIDEdit(event)}}></i></div>
            <div><i class="fa fa-refresh" aria-hidden="true" onClick={event=>{handleSubscriberIDRefresh(event)}} disabled={viewOnly}></i></div></>:
            <div><i class="fa fa-check" aria-hidden="true" onClick={event=>{handleSubscriberIDClose(event)}} disabled={viewOnly}></i></div>}</>} 
            </Form.Group>
            </Col>
          </Row> 
           <Row>
            <Col sm={6} className="mb-3">
              <Form.Group id="hname">
                <Form.Label>Subscriber Type</Form.Label>
               <Form.Select value={subscriberDetails.subscriptionType} 
                disabled={viewOnly} ref={inputSubStatus} onKeyDown={event=>{handleEventKey(event,"4")}} 
                onChange={(event)=>{setsubscriberDetails({...subscriberDetails, subscriptionType:event.target.value})}}
               >
                  <option value="NA">NA</option>
                  <option value="HardOnline">Hard Copy + Online</option>
                  <option value="Online">Only Online</option>
                
                </Form.Select>
              </Form.Group>
            </Col>
            <Col sm={6} className="mb-3">
              <Form.Group className="mb-2">
                <Form.Label>Gender</Form.Label>
                <Form.Select value={subscriberDetails.subGender} 
                disabled={viewOnly} ref={inputSubStatus} onKeyDown={event=>{handleEventKey(event,"4")}} 
                onChange={(event)=>{setsubscriberDetails({...subscriberDetails, subGender:event.target.value})}}
               >
                  <option value="NA">NA</option>
                  <option value="Active">Male</option>
                  <option value="Expired">Female</option>
                  <option value="Suspended">Institute or Library</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6} className="mb-3">
              <Form.Group id="hname">
                <Form.Label>Date Registered</Form.Label>
                <Form.Control type="date" value={subscriberDetails.regDate}
                  disabled={viewOnly} ref={inputRegDate} onKeyDown={event=>{handleEventKey(event,"3")}} 
                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, regDate:event.target.value})}}
                  />
              </Form.Group>
            </Col>
            <Col sm={6} className="mb-3">
              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Select value={subscriberDetails.subStatus} 
                disabled={viewOnly} ref={inputSubStatus} onKeyDown={event=>{handleEventKey(event,"4")}} 
                onChange={(event)=>{setsubscriberDetails({...subscriberDetails, subStatus:event.target.value})}}
               >
                  <option value="Active">Active</option>
                  <option value="Expired">Expired</option>
                  <option value="Suspended">Suspended</option>
                  <option value="Cancelled">Cancelled</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6} className="mb-3">
              <Form.Group id="hname">
                <Form.Label>Start Date</Form.Label>
                <Form.Control required type="date" value={subscriberDetails.startDate}
                  disabled={viewOnly} ref={inputStartDate} onKeyDown={event=>{handleEventKey(event,"5")}} 
                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, startDate:event.target.value})}}
                  />
              </Form.Group>
            </Col>
            <Col sm={6} className="mb-3">
              <Form.Group className="mb-2">
                <Form.Label>End Date</Form.Label>
                <Form.Control required type="date"  value={subscriberDetails.endDate}
                  disabled={viewOnly} ref={inputEndDate} onKeyDown={event=>{handleEventKey(event,"6")}} 
                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, endDate:event.target.value})}}
                  />
              </Form.Group>
            </Col>
          </Row>                  
          <Row>
          <Col md={12} className="mb-3">
              <Form.Group id="emal">
                <Form.Label>Email Address</Form.Label>
                 <div
                    className="
                      bg-white border rounded-4 p-3 d-flex flex-wrap align-items-center
                      g-2 shadow-sm focus-within-ring">
                    {subscriberDetails.emailList && subscriberDetails.emailList.map((email) => (
                      <EmailChip
                        key={email}
                        email={email}
                        onRemove={handleRemoveEmail}
                        isPrimary={email === subscriberDetails.emailID}
                        viewOnly={viewOnly}
                      />
                    ))}
                    <input
                      type="email"
                      value={inputValue}
                      disabled={viewOnly} 
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={handleKeyDown}
                      onPaste={handlePaste}
                      placeholder={subscriberDetails.emailList && subscriberDetails.emailList.length === 0 ? "Add recipients..." : ""}
                      className="
                        flex-grow-1 bg-transparent border-0 p-1 text-dark
                        min-w-[150px] placeholder-text-muted
                      "
                    />
                  </div>
                 <div className="mt-4 bg-light border rounded-3 p-4 shadow-inset">
            <h2 className="h5 fw-semibold text-dark mb-3">
              Current Recipients ({subscriberDetails.emailList && subscriberDetails.emailList.length}):
            </h2>
            {subscriberDetails.emailList && subscriberDetails.emailList.length > 0 ? (
              <ul className="list-unstyled text-dark ps-3">
                {subscriberDetails.emailList.map(email => (
                  <li key={email}>
                    {email}
                    {email === subscriberDetails.emailID && (
                      <span className="badge text-bg-primary rounded-pill ms-2">
                        Primary
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted fst-italic">No emails have been added yet.</p>
            )}
          </div>
                {/*<Form.Control type="email" value={subscriberDetails.emailID}
                  disabled={viewOnly} ref={inputEmailID} onKeyDown={event=>{handleEventKey(event,"7")}} 
                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, emailID:event.target.value})}}
                  />*/}
              </Form.Group>
            </Col>
            </Row>
          <Row>
            <Col sm={6} className="mb-3">
            <Form.Label>Contact Number</Form.Label>
            <Row>
              <Col sm={4} className="mb-3">
              <Form.Group id="areanumber">
                <Form.Select type="select" name="courseName"
                                  value={subscriberDetails.areaCode} 
                                  disabled={viewOnly} ref={inputAreaCode} onKeyDown={event=>{handleEventKey(event,"8")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, areaCode:event.target.value})}}
                                >
                                  {phoneCode.map(item => {
                                return (<option key={item.Code} value={item.Code}>{item.Code}</option>);
                              })}
                  </Form.Select>
                 </Form.Group>
            </Col>
             <Col sm={8} className="mb-3">
              <Form.Group id="mnumber">
                <Form.Control required type="number" placeholder="Enter your contact number" 
                                disabled={viewOnly} ref={inputContactNo} onKeyDown={event=>{handleEventKey(event,"9")}} 
                                value={subscriberDetails.contactNo} onChange={(event)=>{setsubscriberDetails({...subscriberDetails, contactNo:event.target.value})}}
                />
              </Form.Group>
            </Col>
             
            </Row>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="copies">
                <Form.Label>No. of Copies</Form.Label>
                <Form.Control required type="number" value={subscriberDetails.copies}
                                  disabled={viewOnly} ref={inputCopies} onKeyDown={event=>{handleEventKey(event,"11")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, copies:event.target.value})}}
                  />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="category">
                <Form.Label>Category {subscriberDetails.categoryID}</Form.Label>
                <Form.Select value={subscriberDetails.categoryID}
                        disabled={viewOnly} ref={inputCategoryID} onKeyDown={event=>{handleEventKey(event,"10")}} 
                        onChange={(event)=>{setsubscriberDetails({...subscriberDetails, categoryID:event.target.value})}}>
                  {journalCategory.map(item => {
                    return (
                    <option key={item.id} value={item.details}>{item.details}</option>
                    );
                  })}
            </Form.Select>              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="category">
                <Form.Label>Sub Category</Form.Label>
                <Form.Select value={subscriberDetails.subCategory}
                        disabled={viewOnly} ref={inputCategoryID} onKeyDown={event=>{handleEventKey(event,"10")}} 
                        onChange={(event)=>{setsubscriberDetails({...subscriberDetails, subCategory:event.target.value})}}>
                  {journalsubCategory.map(item => {
                    return (
                    <option key={item.name} value={item.name}>{item.name}</option>
                    );
                  })}
            </Form.Select>              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6} className="mb-3">
              <Form.Group id="hname">
                <Form.Label>House Name</Form.Label>
                <Form.Control required type="text" value={subscriberDetails.houseName}
                                  disabled={viewOnly} ref={inputHouseName} onKeyDown={event=>{handleEventKey(event,"12")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, houseName:(event.target.value).toUpperCase()})}}
                  />
              </Form.Group>
            </Col>
            <Col sm={6} className="mb-3">
              <Form.Group className="mb-2">
                <Form.Label>Address</Form.Label>
                <Form.Control required type="text" placeholder="Enter Full Address" value={subscriberDetails.addressStreet}
                                  disabled={viewOnly} ref={inputAddressStreet} onKeyDown={event=>{handleEventKey(event,"13")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, addressStreet:(event.target.value).toUpperCase()})}}
                  />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6} className="mb-3">
              <Form.Group id="hname">
                <Form.Label>City</Form.Label>
                <Form.Control required type="text" value={subscriberDetails.addressCity}
                                  disabled={viewOnly} ref={inputAddressCity} onKeyDown={event=>{handleEventKey(event,"14")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, addressCity:(event.target.value).toUpperCase()})}}
                  />
              </Form.Group>
            </Col>
            <Col sm={6} className="mb-3">
              <Form.Group className="mb-2">
                <Form.Label>State</Form.Label>
                <Form.Control required type="text" placeholder="Enter State" value={subscriberDetails.addressState}
                                  disabled={viewOnly} ref={inputAddressState} onKeyDown={event=>{handleEventKey(event,"15")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, addressState:(event.target.value).toUpperCase()})}}
                  />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group id="zip">
                <Form.Label>Pincode</Form.Label>
                <Form.Control required type="tel" placeholder="Postal Pincode" value={subscriberDetails.addressPincode}
                                  disabled={viewOnly} ref={inputAddressPincode} onKeyDown={event=>{handleEventKey(event,"16")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, addressPincode:event.target.value})}}
                />
              </Form.Group>
            </Col>
            <Col sm={6} className="mb-3">
              <Form.Group id="country">
                <Form.Label>Country</Form.Label>
                <Form.Control required type="text" placeholder="Enter Country" value={subscriberDetails.country}
                                  disabled={viewOnly} ref={inputCountry} onKeyDown={event=>{handleEventKey(event,"17")}} 
                                  onChange={(event)=>{setsubscriberDetails({...subscriberDetails, country:(event.target.value).toUpperCase()})}}
                  />
              </Form.Group>
            </Col>
          </Row>    
          {!viewOnly && <>{subscriberFormType==="Edit"?<div className="mt-3 text-center">
                  <Button variant="primary" type="submit" onClick={(event)=>{handleSubcriberEdit(event)}}>Update</Button>
                </div>:subscriberFormType==="New"?<div className="mt-3 text-center">
                  <Button variant="primary" type="submit" onClick={(event)=>{handleSubcriberNew(event)}}>Save</Button>
                </div>:null}</>}
</Card.Body>
</Card>
</div>
</div>
  )
}
